interface LogoProps {
  className?: string
}

export function ClickLogo({ className }: LogoProps) {
  return <img src="/click_logo.png" alt="Click" className={className} />
}

export function PaymeLogo({ className }: LogoProps) {
  return <img src="/payme_logo.jpg" alt="Payme" className={className} />
}

export function RahmatLogo({ className }: LogoProps) {
  return <img src="/raxmat.png" alt="Rahmat" className={className} />
}

export function YandexEatsLogo({ className }: LogoProps) {
  return <img src="/yandex_eats_logo.png" alt="Yandex Eats" className={className} />
}

export function EscPosLogo({ className }: LogoProps) {
  return <img src="/esc_pos_logo.png" alt="ESC/POS" className={className} />
}

export function StarPrntLogo({ className }: LogoProps) {
  return <img src="/starprnt_logo.png" alt="StarPRNT" className={className} />
}
